import React, { createContext, useState, useCallback } from 'react';
import { Alert } from '../components/NotificationAlert/NotificationAlert';

interface NotificationContext {
  notification: Alert | undefined;
  showNotification: (alert: Alert) => void;
  hideNotification: () => void;
}

const defaultContext: NotificationContext = {
  notification: undefined,
  showNotification: () => {},
  hideNotification: () => {},
};

const NotificationContext = createContext<NotificationContext>(defaultContext);

const NotificationProvider: React.FC = ({ children }) => {
  const [notification, setNotification] = useState<Alert | undefined>();

  const showNotification = useCallback((alert: Alert) => {
    setNotification(alert);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(undefined);
  }, []);

  return (
    <NotificationContext.Provider value={{ notification, showNotification, hideNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationProvider };
export default NotificationProvider;
